import { Form } from "react-bootstrap";

export default function FileInput({
  fileType,
  selectedFile,
  hasExistingUpload,
  onSelect,
  error,
}) {
  const hasSelectedFile = !!selectedFile;

  if (fileType === "none") {
    return null; // No file type specified, nothing to render
  }

  return (
    <div className="upload-input-type-file full-width">
      <input
        key={`image-input-${Date.now()}`} // Force re-render when preview changes
        onChange={(e) => onSelect(e.target.files[0])}
        type="file"
        name="file-input"
        id="file-input"
        accept={fileType === "image" ? "image/*" : "video/*,image/*"}
      />
      <label
        htmlFor="file-input"
        className={hasSelectedFile ? "file-selected" : ""}
      >
        <img src="/images/plus-icon-img.png" alt="upload" />
        <h4>
          {hasExistingUpload && hasSelectedFile
            ? "Replace"
            : hasExistingUpload
            ? "Change"
            : hasSelectedFile
            ? "Change Selection"
            : "Upload"}{" "}
          {fileType === "image" ? "Image" : "File"}
        </h4>
        {hasSelectedFile && (
          <small className="text-primary d-block mt-1">
            {selectedFile.name || "New file selected"}
          </small>
        )}
      </label>
      {error && (
        <Form.Text className="text-danger mt-2">
          Please upload a photo before continuing.
        </Form.Text>
      )}
    </div>
  );
}
